export default __webpack_public_path__ + "static/qlab-3-icon-2802190dc6dd972c60a4bf5dd7d39271.png";